import React from 'react';
import { bool, shape, string } from 'prop-types';

const SnowRemoval = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.4239 7.31799C19.5006 8.24129 18.1269 8.43347 17.012 7.90149L14.06 10.8535L16.1813 12.9748L16.2876 13.0867C17.3516 14.2644 17.3162 16.0825 16.1813 17.2175L11.2315 22.1672L1.33203 12.2677L6.28178 7.31799C7.45335 6.14641 9.35285 6.14641 10.5244 7.31799L12.6457 9.43931L15.5978 6.48727C15.087 5.41658 15.2436 4.10722 16.0749 3.18721L16.1813 3.07535L17.5955 1.66113L21.8381 5.90377L20.4239 7.31799ZM9.11021 8.7322C8.74415 8.36615 8.16472 8.34297 7.77195 8.66315L7.69599 8.7322L4.16046 12.2677L5.57467 13.6819L9.81731 9.43931L9.11021 8.7322ZM6.98889 15.0962L8.4031 16.5104L12.6457 12.2677L11.2315 10.8535L6.98889 15.0962ZM9.81731 17.9246L11.2315 19.3388L14.7671 15.8033C15.1575 15.4128 15.1575 14.7796 14.7671 14.3891L14.06 13.6819L9.81731 17.9246ZM17.5955 4.48956C17.205 4.88006 17.205 5.51324 17.5955 5.90377C17.986 6.2943 18.6192 6.2943 19.0097 5.90377L17.5955 4.48956Z" fill="currentColor" />
  </svg>
);

SnowRemoval.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default SnowRemoval;
